import { SPLIT_KEY } from './const';

export const ORG_CONFIRMATION_SUBMIT_TREATMENT = {
  name: 'VAULT-660-org-confirmation-submit',
  treatments: {
    on: 'on',
    off: 'off',
  },
};
export const ORG_CONFIRMATION_WITH_CREATE_KYC_SUBMIT_TREATMENT = {
  name: 'VAULT-660-org-confirmation-with-create-kyc-submit',
  treatments: {
    on: 'on',
    off: 'off',
  },
};
export const TREATMENTS = [
  ORG_CONFIRMATION_SUBMIT_TREATMENT,
  ORG_CONFIRMATION_WITH_CREATE_KYC_SUBMIT_TREATMENT,
];

if (
  !process.env.REACT_APP_SPLIT_CLIENT_SIDE_API_KEY &&
  !process.env.REACT_APP_SPLIT_IO_KEY
) {
  throw new Error(
    'env var REACT_APP_SPLIT_CLIENT_SIDE_API_KEY or REACT_APP_SPLIT_IO_KEY is required',
  );
}

export const SPLIT_CONFIG: SplitIO.IBrowserSettings | undefined = {
  core: {
    authorizationKey: (process.env.REACT_APP_SPLIT_CLIENT_SIDE_API_KEY ||
      process.env.REACT_APP_SPLIT_IO_KEY)!,
    key: SPLIT_KEY,
  },
  debug: false,
};
